/**
 * Honest empty MQTT page. No broker, no invent, no listener create.
 */

import { Link } from 'react-router-dom';
import { mqttAbsentCopy } from './mqttAbsentHonesty';

export default function MqttAbsentPage() {
  const copy = mqttAbsentCopy();

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-lg p-6 space-y-3">
      <h1 className="text-lg font-semibold text-amber-950">{copy.title}</h1>
      <p className="text-sm text-amber-900">{copy.body}</p>
      <div className="flex flex-wrap gap-3 text-sm">
        <Link to="/iotshack/dashboard" className="text-blue-700 hover:text-blue-800">
          Dashboard
        </Link>
        <Link to="/iotshack/listeners" className="text-blue-700 hover:text-blue-800">
          Listeners (TCP/UDP/HTTP)
        </Link>
      </div>
    </div>
  );
}
